import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { viewInvoiceApi } from '../../apis/invoicingApis'
import InvoiceInput from '../../components/Invoicing/InvoiceInput'
import { resetInvoicingError, resetInvoicingSuccess, addInvoiceAction, viewInvoiceAction } from './../../redux/invoicing'
type AppProps = {
    date?: any;
    id?: number | null;
    name?: any;
    type?: string;
    client_code?: any;
    token?: string | null;
    dispatchViewInvoiceAction?: any;
    resetInvoicingError: any;
    resetInvoicingSuccess: any;
    viewInvoiceData?: any
    history?: any
}

const EditInvoice = ({
    id,
    date,
    name,
    type,
    client_code,
    token,
    dispatchViewInvoiceAction,
    resetInvoicingSuccess,
    resetInvoicingError,
    viewInvoiceData,
    history
}: AppProps) => {


    const [editInvoice, setEditinvoice] = useState({})

    let finalDate = moment(date).format('DD-MM-YYYY');
    let finalName = name?.split(' ').length > 1 ? name?.split(' ').join('_') : name;
    let finalInvoiceName = `${finalDate}_${finalName}`;

    useEffect(() => {
        if (viewInvoiceData) {

            setEditinvoice(true)
        }
    }, [viewInvoiceData])

    useEffect(() => {
        const {
            location:{
                state :{
                    invoice_id =0,
                    client_code= 0,
                    type=''
                }={}
            }={}
        } = history

        let data = {
            token, type, client_code, invoice_id
        }
        dispatchViewInvoiceAction(data)
    }, [])
  
    return (
     
        viewInvoiceData && editInvoice ?
            <InvoiceInput
                finalColumnList={viewInvoiceData.data}
                type={type}
                client_code={client_code}
                invoiceAction='edit'
            /> : null
    
    )
};

const mapStateToProps = (state: any) => ({
     token: state.auth.token,
    error: state.invoicing.error,
    success: state.invoicing.success,
    message: state.invoicing.message,
    statusCode: state.invoicing.statusCode,
    viewInvoiceData: state.invoicing.viewInvoiceData,
})

const mapDispatchToProps = (dispatch: any) => ({
    dispatchViewInvoiceAction: (data: any) => dispatch(viewInvoiceAction(data)),
    resetInvoicingError: () => dispatch(resetInvoicingError()),
    resetInvoicingSuccess: () => dispatch(resetInvoicingSuccess())
})

export default connect(mapStateToProps, mapDispatchToProps)(EditInvoice)